<!-- 隐身设置 -->
<template>
	<div class="campus-announcement">
		<div class="timeSwitch">
			<div class="switchBox">
				<div class="time-box">
					<span class="time-left">时间段</span>
					<span class="time-star">开始时间</span>
					<span class="time-end">结束时间</span>
				</div>
				<div class="time-input">
					<span class="morningTime">时段1</span>
					<input type="text" v-model="Dvalue.time1From" class="input-left">
					<input type="text" v-model="Dvalue.time1To">
				</div>
				<div class="time-input">
					<span class="morningTime">时段2</span>
					<input type="text" v-model="Dvalue.time2From" class="input-left">
					<input type="text" v-model="Dvalue.time2To">
				</div>
				<div class="time-input">
					<span class="morningTime">时段3</span>
					<input type="text" v-model="Dvalue.time3From" class="input-left">
					<input type="text" v-model="Dvalue.time3To">
				</div>
				<div class="time-input">
					<span class="morningTime">时段4</span>
					<input type="text" v-model="Dvalue.time4From" class="input-left">
					<input type="text" v-model="Dvalue.time4To">
				</div>
				<div class="time-input">
					<span class="morningTime">时段5</span>
					<input type="text" v-model="Dvalue.time5From" class="input-left">
					<input type="text" v-model="Dvalue.time5To">
				</div>
				<div class="openTime">
					<el-checkbox-group v-model="checkList">
						<el-checkbox label="1">周一</el-checkbox>
						<el-checkbox label="2">周二</el-checkbox>
						<el-checkbox label="3">周三</el-checkbox>
						<el-checkbox label="4">周四</el-checkbox>
						<el-checkbox label="5">周五</el-checkbox>
						<el-checkbox label="6">周六</el-checkbox>
						<el-checkbox label="7">周日</el-checkbox>
						<div class="reminderXiu">时间格式：HH :MM 例如：10：30</div>
					</el-checkbox-group>
				</div>
				<el-button class="buttonSave" @click="setSystemHidingClick">保存设置</el-button>
			</div>
		</div>
	</div>
	<!-- 
}
-->
</template>
<script>
	import {
		setSystemHidingFing,
		setSystemHidingUpdate
	} from "@/assets/api/logapi";
	import { ElMessage,ElLoading } from 'element-plus'
	export default {
		components: {

		},
		data() {
			return {
				checked1: true,
				checked2: false,
				checkList: [],
				elLoading:undefined,
				Dvalue: {
					time1From: "",
					time1To: "",
					time2From: "",
					time2To: "",
					time3From: "",
					time3To: "",
					time4From: "",
					time4To: "",
					time5From: "",
					time5To: ""
				}
			};
		},
		created() {
			this.setSystemHidingSearch()
		},
		mounted() {

		},
		methods: {
			setSystemHidingSearch() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id
				}
				this.openElLoading("正在获取时段数据")
				setSystemHidingFing(params).then((res) => {
					// console.log(res,'隐身设置接口');
					let data = res.data.data;
					this.checkList = data.days.slice(1, -1).split(',').map(String);
					this.Dvalue = {
						time1From: data.from1,
						time1To: data.to1,
						time2From: data.from2,
						time2To:data.to2,
						time3From: data.from3,
						time3To:data.to3,
						time4From:data.from4,
						time4To:data.to4,
						time5From: data.from5,
						time5To: data.to5,
						userId: data.userId,
						onOff:data.onOff,
						orgCode:data.orgCode,
						days:data.days
					}
					this.closeElLoading();
				}).catch((err) => {
					this.closeElLoading();
					console.log(err, '隐身设置i接口失败');
				})
			},
			setSystemHidingClick() {
				const days = this.checkList.map(Number)
				if (this.checked1 === true) {
					const params = {
						...this.Dvalue,
						days: days,
						userId:JSON.parse(localStorage.getItem('user')).id,
					}
					this.openElLoading("正在保存设置")
					// console.log('我被勾选了');
					setSystemHidingUpdate(params).then((res) => {
						// console.log(res,'成功');
						this.closeElLoading();
						this.$message({
							type: 'success',
							message: '保存成功!'
						});
					}).catch((err) => {
						this.closeElLoading();
						console.log(err, '失败');
					})
				} else {
					console.log('我没被勾选');
				}
			},
			
			openElLoading(text){
				this.elLoading = ElLoading.service({
					lock: true,
					text: `${text}`,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			
			closeElLoading(){
				if(this.elLoading){
					this.elLoading.close();
					this.elLoading = null;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.campus-announcement {
		height: 95%;
		background-color: #fff;
		padding-top: 20px;

		.timeSwitch {
			width: 52%;
			margin-top: 30px;
			height: 450px;
			border: 0.5px solid #ccc;
			margin-left: 20%;

			.switchBox {
				height: 280px;
				width: 800px;
				border: 0.5px solid #ccc;
				margin-left: 20px;
				// background: greenyellow;
				margin-top: 40px;

				.time-box {
					padding-top: 20px;
					// display: flex;
					// justify-content: space-around;
					border-bottom: 1px solid #ccc;
					height: 50px;

				}

				.time-left {
					margin-left: 8% !important;
				}

				.time-star {
					margin-left: 22%;
				}

				.time-end {
					margin-left: 32%;

				}

				.time-input {
					display: flex;
					// justify-content: space-between;
					justify-content: space-around;

					margin-top: 20px;

				}

				.time-input input {
					width: 180px;
					border: 1px solid gray;
				}

				.morningTime {
					// margin:10px 105px;
				}

				.input-left {
					// margin-right: 100px;
					// margin-left: 60px;
				}

			}

			.timeFormat {
				// margin-top: 10px;
				margin-left: 20px;
				font-size: 13px;
				color: gray;

			}

			.buttonSave {
				height: 30px;
				margin-top: 20px;
				margin-left: 380px;
				border: 1px solid gray;
			}

			.reminderXiu {
				font-size: 13px;
				color: red;
				margin-left: 170px;
				margin-top: 10px;

			}

			.openTime {
				margin-top: 40px;
				font-size: 14px;
				margin-left: 150px;
			}

		}
	}
</style>